export default __webpack_public_path__ + "static/media/upload_photo_04.a6289d85.svg";